export default () => {
  /** Is there a map on the current page? */
  const mapElement = document.querySelector('.js-map')
  if (!mapElement) return

  /**
   * Get coordinates from html data attributes.
   * Return early if values are missing.
   */
  let coordinates = getCoordinates(mapElement)
  if (!coordinates) {
    console.log(
      'Missing coordinates. Fill all required fields in StoreMap pageblock.'
    )
    return
  }

  /**
   * Load the API and call the map.
   */
  const apiKey = 'AIzaSyBXwapq2IH0jnnMBdV3cAUFAyqFOM0JAxU'
  loadGoogleMapsAPI(apiKey)

  window.mapsCallback = () => {
    displayMap(coordinates.lat, coordinates.lng, coordinates.zoom)
  }

  /**
   * Build the map
   */
  function displayMap(lat, lng, zoom) {
    const coordinates = {
      lat: lat,
      lng: lng
    }

    const options = {
      zoom: zoom,
      center: new window.google.maps.LatLng(coordinates.lat, coordinates.lng),
      scrollwheel: false,
      draggable: true,
      zoomControl: true,
      scaleControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false
    }

    // Show the map
    const map = new window.google.maps.Map(
      document.getElementById('maps'),
      options
    )

    // Show the marker
    createMarker(map, lat, lng)
  }

  /**
   * Create a marker
   */
  function createMarker(map, lat, lng) {
    const icon = {
      url: '/wp-content/themes/huisvesting/img/marker.svg',
      scaledSize: new window.google.maps.Size(50, 50) // scaled size
    }

    const marker = new window.google.maps.Marker({
      map,
      position: {
        lat: lat,
        lng: lng
      },
      icon: icon
    })

    return marker
  }

  /**
   * Load google maps api
   */
  function loadGoogleMapsAPI(key) {
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${key}&callback=mapsCallback`
    document.body.appendChild(script)
  }

  /**
   * Get coordinates: lng, lat, zoom
   */
  function getCoordinates(el) {
    if (!el.dataset.lat || !el.dataset.lng || !el.dataset.zoom) {
      return false
    }

    let lat = parseFloat(el.dataset.lat)
    let lng = parseFloat(el.dataset.lng)
    let zoom = parseFloat(el.dataset.zoom)

    return {
      lat: lat,
      lng: lng,
      zoom: zoom
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/Map.js